import * as XLSX from "xlsx";

export type FileType = "excel" | "csv";

export interface GenerateFileOptions {
  headers: string[];
  data: Record<string, any>[];
  filename?: string;
  fileType: FileType;
}

export const generateFile = async (
  options: GenerateFileOptions
): Promise<File> => {
  const { headers, data, filename = "audience_data", fileType } = options;

  // Prepare worksheet data
  const worksheetData = [
    headers,
    ...data.map((row) => headers.map((header) => row[header] ?? "")),
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // Timestamp
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19);

  if (fileType === "csv") {
    // 👉 CSV GENERATION
    const csv = XLSX.utils.sheet_to_csv(worksheet);

    const finalFilename = `${filename}_${timestamp}.csv`;

    return new File([csv], finalFilename, {
      type: "text/csv;charset=utf-8;",
    });
  }

  // 👉 EXCEL GENERATION
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Audience Data");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const finalFilename = `${filename}_${timestamp}.xlsx`;

  return new File([excelBuffer], finalFilename, {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
};

export const filterValidRows = (
  data: Record<string, any>[],
  headers: string[],
  validateRow: (row: Record<string, any>, headers: string[]) => boolean
): Record<string, any>[] => {
  return data.filter((row) => validateRow(row, headers));
};
